import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule, HttpClientXsrfModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {ThemeConstantService} from './services/theme-constant.service';
import {CommonModule} from '@angular/common';
import {PipesModule} from '@shared/pipes/pipes.module';
import {AntDesignModule} from '@shared/ant-design.module';
import {ExtendFormItemComponent} from '@shared/components/extend-form-item/extend-form-item.component';
import {ExtendFormComponent} from '@shared/components/extend-form/extend-form.component';
import {AntIconModule} from '@shared/icons/ant-icon.module';
import {TablerIconModule} from '@shared/icons/tabler-icon.module';
import {CustomHttpInterceptor} from '@core/interceptor/http-intercepter';
import {AppTableComponent} from '@shared/components/app-table/app-table.component';
import {AppTableWrapComponent} from '@shared/components/app-table-wrap/app-table-wrap.component';
import {AppEmptyComponent} from '@shared/components/app-empty/app-empty.component';
import {ImportDataComponent} from '@shared/components/import-data/import-data.component';
import {InputGroupIconComponent} from '@shared/components/input-group-icon/input-group-icon.component';
// import {NgChartjsModule} from 'ng-chartjs';
import {XsrfInterceptor} from '@core/interceptor/xsrf-interceptor';
import {SliderCaptchaComponent} from '@shared/components/slide-captcha/slide-captcha.component';
import {DownloadFileConfirmComponent} from '@shared/components/download-file-confirm/download-file-confirm.component';
import {EditorModule, TINYMCE_SCRIPT_SRC} from '@tinymce/tinymce-angular';
import {UploadImageSimpleComponent} from "@shared/components/upload-image-simple/upload-image-simple.component";
import {NgApexchartsModule} from "ng-apexcharts";
import {NgxPrintModule} from "ngx-print";
const MODULES = [AntDesignModule, PipesModule, PerfectScrollbarModule, AntIconModule, TablerIconModule,
  // NgChartjsModule,
  EditorModule,NgApexchartsModule,NgxPrintModule
];
const COMPONENTS = [DownloadFileConfirmComponent, SliderCaptchaComponent, ExtendFormItemComponent, ExtendFormComponent, AppTableWrapComponent, AppTableComponent, AppEmptyComponent, ImportDataComponent, InputGroupIconComponent, UploadImageSimpleComponent];

@NgModule({
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    ...MODULES,
    ...COMPONENTS
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'CSRF-TOKEN',
      headerName: 'CSRF-TOKEN'
    }),
    ...MODULES,
  ],
  declarations: [
    ...COMPONENTS
  ],
  providers: [
    ThemeConstantService,
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XsrfInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})

export class SharedModule {
}
